export default __webpack_public_path__ + "static/media/1777.d2f7727a.png";